import { push } from "svelte-spa-router"
import ApplicationState from "../Stores/applicationStates"
import { getRequest } from "./apiMethods"

let userName = ""
ApplicationState.subscribe((value) => {
  userName = value.name
})

const errorDictionary = {
  BULK_UPLOAD_HAS_NO_ENTRIES_REMOVING_SESSION: "The bulk template has no document entries. The session has been removed.",
  BULK_UPLOAD_ALREADY_HAS_ENTRIES: "The bulk template already contains document entries. Please upload a different set of documents.",
  ERROR_P2B_NOTIFIED: "We've encountered an error on our end. Please try again after some time.",
  NO_EMAIL: "Please provide an email address.",
  NO_PASS: "Please enter a password.",
  NO_USER: "The user you are looking for does not exist.",
  NO_FILENAME: "Please ensure that you have provided the filename parameter in the request body.",
  NO_ID: "Please make sure to include the document ID when sending the request.",
  NO_FILE: "Please make sure to upload the file.",
  DOCUMENT_DOES_NOT_EXIST: "Please restart the publishing process as the document ID does not exist.",
  DOCUMENT_ALREADY_PUBLISHED: "Sorry, but the document you're trying to access has already been published.",
  DOCUMENT_HAS_FILE: "You've already submitted a file to be linked with this document ID.",
  FILE_LINKED_DIFFERENT_DOCUMENT: "It seems you've already submitted this file for a different document ID.",
  METADATA_LENGTH_EXCEEDED: "Oops, the length of the metadata value has gone over the maximum character limit.",
  OPTIONS_LENGTH_EXCEEDED: "Oops, the length of the options value has gone over the maximum character limit.",
  DOCUMENT_HAS_DATA: "You've already submitted data to be linked with this document ID.",
  INVALID_METADATA_JSON_STRUCTURE: "The structure of the metadata provided is not valid.",
  INVALID_JSON_STRUCTURE: "The structure of the json provided is not valid.",
  INVALID_OPTIONS_JSON_STRUCTURE: "The structure of the options provided is not valid.",
  NO_SIGNATURE: "Please include the signature in the request body to proceed.",
  DOCUMENT_HAS_NO_DATA: "Sorry, but information for the document hasn't been provided.",
  DOCUMENT_HAS_NO_FILE: "Sorry, but the document hasn't been provided.",
  SIGNATURE_VERIFICATION_FAILED: "Uh-oh, the signature you provided failed to verify you request.",
  FAILED_TO_QUEUE_DOCUMENT: "API can't line up the document for publishing, try sending the request again.If this keeps happening, feel free to get in touch with us.",
  CANT_REMOVE_PUBLISHED: "Unfortunately, we can't remove the document since it's already published.",
  CANT_REMOVE_QUEUED: "We can't remove the document right now because it's currently in the queue. If you'd like to proceed with removal, please wait for the document to be published and then revoke it.",
  ALREADY_REVOKED: "The document has already been revoked.",
  DOCUMENT_NOT_PUBLISHED: "In order to revoke the document, you need to first publish it.",
  NO_TOKEN: "Your session has expired.",
  REQUEST_FAILED_AT_3RD_PARTY: "The request encountered an issue with a third-party service.",
  INVALID_EXCEL_FILE: "The Excel file you uploaded is not valid. Please upload a different file.",
  INVALID_HEADER_FOUND_IN_SPREADSHEET: "The header row in the spreadsheet / templates has been modified after download, which is not allowed.",
  MULTIPLE_SHEET_NOT_ALLOWED: "You can only upload Excel files with a single sheet. Multiple sheet Excel files are not allowed.",
  NOT_A_VALID_DATE_OBJECT: "An invalid date was found in the Excel file.",
  INVALID_TOKEN: "Your session has expired. Please log in again.",
  BULK_UPLOAD_DOES_NOT_EXIST: "The bulk template you were expecting could not be found.",
  NETWORK_ERROR: "It seems you're offline or experiencing network disconnection.",
  INVALID_PASSWORD: "Sorry, the password you entered is incorrect. Please try again.",
  BULK_UPLOAD_HAS_NO_ENTRIES: "The template doesn't contain any documents. Please upload some documents to proceed.",
  LINKED_FILE_TEMPLATE_NOT_FOUND: "We couldn't find the file template associated with the document template.",
  EMAIL_FAILED_TO_SEND: "The email failed to send because the recipient provided an invalid email address.",
  "2FA_VERIFICATION_FAILED": "The verification code you entered is incorrect. Please enter the correct verification code.",
  TEMPLATE_DOES_NOT_EXIST: "The template you're looking for doesn't exist, possibly because it has been deleted.",
  FILE_TEMPLATE_DOES_NOT_EXIST: "The file template you're looking for doesn't exist, possibly because it has been deleted.",
  DOCUMENT_TEMPLATE_DOES_NOT_EXIST: "The document template you're looking for doesn't exist, possibly because it has been deleted.",
  "3DR_PARTY_API_FAILED": "The API failed because of issues with third-party services.",
  NO_DOCUMENT_ID: "The document ID was not found for the respective document. It's possible that the document has already been released.",
  URL_MISSING_IN_CONTENT: "The email content is missing a URL. Please ensure that you include a URL in the email content, as it's mandatory.",
  INVALID_EMAIL_ADDRESS: "The email address you provided is not valid. Please enter a valid email address.",
  INVALID_EMAIL_DOMAIN: "The email domain you provided is not valid. Please enter a valid email domain.",
  CANNOT_SEND_EMAILS_AS_THERE_IS_NO_ASSOCIATED_TEMPLATE: "You cannot send emails because there is no email template associated with the selected document template.",
  CANNOT_GENERATE_FILES_AS_THERE_IS_NO_ASSOCIATED_TEMPLATE: "You cannot generate files because there is no file template associated with the selected document template.",
  BACKEND_API_FAILED: "The backend API has encountered an issue. If this happens, please inform us so that we can assist you.",
  BOTH_EMAIL_IDS_AND_EMAIL_DOMAIN_NOT_ALLOWED: "The provided email IDs and email domain are not valid, or for some other reasons, they are not allowed.",
  INVALID_NDA_URL: "The NDA URL you provided is not valid. Please provide a valid URL.",
  INVALID_NOTICE_URL: "The notice URL you provided is not valid. Please provide a valid notice URL.",
  OTP_DOES_NOT_MATCH: "The OTP you provided does not match. Please enter a valid OTP.",
  LAYER_ATTRIBUTE_MISSING: "A layer attribute is missing. Please select or enter the required layer attribute.",
  LAYER_TYPE_MISSING: "A layer type is missing. Please select the layer type.",
  EXPIREON_CANNOT_BE_OLDER: "The expiration date cannot be set in the past. Please select a future date.",
  EXPIRY_CANNOT_BE_IN_PAST: "The expiration date cannot be set in the past. Please select a future date.",
  INVALID_DATE: "The date you provided is invalid. Please enter a valid date.",
  INVALID_EXPIREON: "The expiry date you provided is invalid. Please select a valid expiry date.",
  INVALID_LAYER_ATTRIBUTE: "The selected layer attribute is invalid. Please choose or enter a valid layer attribute.",
  FONT_FAMILY_NAME_MISSING: "The font family name is missing in the font link you provided. Please include the font family name.",
  DURATION_MISSING: "The 'from' and/or 'to' query parameters are missing in the request. Please check if these parameters exist and add them if they are not included.",
  INVALID_DURATION: "The 'from' and/or 'to' query parameter(s) do not follow the ISO 8601 standard. Please ensure that these parameters are in the correct format.",
  MISSING_FONT_DATA: "The font-related data is missing.",
  FONT_DOES_NOT_EXIST: "The font you are looking for does not exist.",
  ECDSA_SIGNATURE_GENERATION_FAILED: "Oops, the signature generation failed. This could be due to an invalid fileHash, dataHash, or issues on the server side.",
  DOCUMENT_TEMPLATE_NOT_PROVIDED: "The document template has not been provided, and it's mandatory to proceed to the next step.",
  INVALID_FONT_LINK: "The font link you provided is invalid. Please provide a valid font link.",
  TITLE_DOES_NOT_MATCH_FORMAT: "The title does not match the required format.",
  NAME_DOES_NOT_MATCH_FORMAT: "The bulk session name does not match the required format.",
  INVALID_FILENAME: "The provided filename is invalid. Please provide a valid filename.",
  PASSWORD_CANNOT_BE_SAME: "The old password and new password cannot be the same. Please enter a new password that is different from the old one.",
  SEND_EITHER_FILE_OR_LINK: "Please send either a file or a link.",
  IPFS_ERROR: "There was an issue with IPFS.",
  IPFSERROR: "There was an issue with IPFS.",
  METADATA_MISSING: "The request is missing metadata in the body. Please provide the required metadata.",
  FABRIC_ERROR: "There is an issue connecting to the blockchain.",
  USER_NOT_IN_REDIS: "We cannot locate the user.",
  CANNOT_CHECK_ID_IN_REDIS: "We are unable to verify the issuer ID.",
  PUBKEY_VERIFICATION_BUSY: "The public key verification process is currently busy.",
  BULK_ID_RESERVATION_FAILED: "There was an issue while trying to reserve a bulk ID.",
  TEST_STOP: "The server is currently down for testing purposes.",
  PROXY_PASS_VERIFICATION_FAILED: "The proxy password verification has failed.",
  FETCH_ISSUER_FAILED: "Fetching issuer details has failed.",
  METADATA_INVALID_TYPE: "The type of metadata you provided is invalid.",
  NO_DOC: "No document was found.",
  NO_AUTHENTICATION: "Authentication is required.",
  METHOD_NOT_PERMITTED: "This method is not allowed.",
  ERROR_STRIPPING_LAYER_DATA: "There was an error while stripping layer data.",
  LAYERS_NOT_JSON_STRING: "The layers are not in a valid JSON string format.",
  AUTHENTICATION_FAILED: "The verification code you entered is incorrect. Please enter the correct verification code.",
  BADGE_TEMPLATE_DOES_NOT_EXIST: "The badge template you're looking for doesn't exist, possibly because it has been deleted.",
  BADGE_DOES_NOT_EXIST: "The badge you're looking for doesn't exist.",
  SIGNATURE_IMAGE_EXCEEDS_THE_DIMENSIONS: "The signature image is too large. Please resize it to fit the required dimensions and try again.",
  FILE_SHOULD_BE_IN_PNG_OR_JPG_FORMAT: "The file must be in PNG or JPG format. Please upload a supported file type.",
  BLOCKCHAIN_INVOKE_FAILED: "Blockchain Execution Error",
  BLOCKCHAIN_NON_200_STATUS: "Invalid Response Status from Blockchain",
  MAX_FILE_SIZE_EXCEEDED: "File Size Limit Exceeded",
  USER_NOT_FOUND: "Unable to find User",
  UNAUTHORISED: "Unauthorized access. Permission denied.",
  EMAIL_ALREADY_EXISTS: "This email address is already in use.",
  DUPLICATE_EMAIL_IN_APPROVER: "Duplicate email found in the approvers list.",
  DUPLICATE_EMAIL_IN_SIGNER: "Duplicate email found in the signers list.",
  INVALID_USER_DATA: "User data is invalid or incomplete.",
  INVALID_USER_EMAIL: "The email address provided is invalid.",
  INVALID_EMAIL: "The email address provided is invalid.",
  INVALID_USER_ID: "User ID is invalid or missing.",
  EMPTY_USER_LIST: "No users found.",
  NO_USER_LIST: "No users found.",
  NO_USER_ID: "User ID is required but missing.",
  NO_PENDING_USERS: "No pending users found.",
  OTP_EXPIRED: "OTP has expired. Request a new one",
  OTP_REQUEST_NOT_FOUND: "No OTP request found",
  FAILED_TO_SEND_OTP_EMAIL: "Failed to send OTP via email.",
  CLAIM_EXPIRED: "Claim has expired.",
  CLAIM_DATA_MISSING: "Claim data is missing.",
  CANNOT_FIND_SIGNER_FROM_TOKEN: "Cannot find signer from token.",
  CANNOT_MODIFY_APPROVER_DATA: "Cannot modify approver data.",
  CANNOT_MODIFY_SIGNED_USER: "Cannot modify signed user.",
  CONTACT_SUPPORT: "Please contact support.",
  CONTENT_SIZE_EXCEDEED: "Content size exceeded the allowed limit.",
  DIFF_DOC: "Documents are different.",
  DIFF_SIGN_HASH_DETECTED: "Different sign hash detected.",
  DOCKET_OTHER_ORG: "Docket belongs to another organization.",
  DOCKET_REJECTED: "Docket has been rejected.",
  DOCKET_WAITING_FOR_APPROVAL: "Docket is waiting for approval.",
  DOCS_ARE_DIFF: "Documents do not match.",
  ENCRYPTED_DOCKET_NOT_ALLOWED: "Encrypted docket is not allowed.",
  ERROR_DESERIALISING_SIGNEE_CACHE: "Error deserializing signee cache.",
  ERROR_DESERIALISING_SIGNER_CACHE: "Error deserializing signer cache.",
  ERROR_DESERIALISING__SIGNER_JSON: "Error deserializing signer JSON.",
  ERROR_IN_SIGN_EXTRACT: "Error in extracting sign data.",
  ESIGN_MISSING: "E-sign is missing.",
  FAILED_BLOCKCHAIN_UPDATE: "Failed to update blockchain.",
  FAILED_TO_GENERATE_TOKEN: "Failed to generate token.",
  FAILED_TO_REVOKE: "Failed to revoke.",
  FAILED_TO_SEND_OTP_EMAIL: "Failed to send OTP email.",
  FILE_SHOULD_BE_IN_PNG_OR_JPG_FORMAT: "File should be in PNG or JPG format.",
  FILE_SIZE_MORE_THAN_153KB_NOT_ALLOWED: "File size must not exceed 153KB.",
  INVALID_ACCESS_TOKEN: "Invalid access token.",
  INVALID_BOUNDARY: "Invalid boundary.",
  INVALID_CLAIM: "Invalid claim.",
  INVALID_CLAIM_DATA: "Invalid claim data.",
  INVALID_CONTACT_NUMBER: "Invalid contact number.",
  INVALID_COORDINATES_FOR_PAGE_: "Invalid coordinates for page.",
  INVALID_DATE: "Invalid date.",
  INVALID_DOCKET_ID: "Invalid docket ID.",
  INVALID_ID: "No data available for the provided ID.",
  INVALID_DOCUMENT_ID: "Invalid document ID.",
  INVALID_FILE_INPUT: "Invalid file input.",
  INVALID_JSON_FORMAT: "Invalid JSON format.",
  INVALID_JSON_STRUCTURE: "Invalid JSON structure.",
  INVALID_ORGID: "Invalid organization ID.",
  INVALID_OTP: "Invalid OTP.",
  INVALID_PAGE: "Invalid page.",
  INVALID_PAGE_LIST: "Invalid page list.",
  INVALID_PAGE_NO: "Invalid page number.",
  INVALID_PARAMS: "Invalid parameters.",
  INVALID_PLACEMENTS: "Invalid placements.",
  INVALID_PLACEMENT_COORDINATES: "Invalid placement coordinates.",
  INVALID_PLACEMENT_DATA: "Invalid placement data.",
  INVALID_PLACEMENT_PAGES: "Invalid placement pages.",
  INVALID_REQUEST_BODY: "Invalid request body.",
  INVALID_REQUEST_DATA: "Invalid request data.",
  INVALID_REQUEST_ID: "Invalid request ID.",
  INVALID_ROLE: "Invalid role.",
  INVALID_STATUS: "Invalid status.",
  INVALID_USER_DATA: "Invalid user data.",
  INVALID_USER_EMAIL: "Invalid user email.",
  INVALID_USER_ID: "Invalid user ID.",
  MISSING_PARAMETER: "Required parameter is missing.",
  NON_APPROVED_DOC: "Document is not approved.",
  NON_PDF_FILE: "File is not a PDF.",
  NO_COORDINATES: "Coordinates are missing.",
  NO_CO_ORDINATES: "Coordinates are required.",
  NO_DOCKET: "Docket is required but missing.",
  NO_DOCKET_ID: "Docket ID is required but missing.",
  NO_DOC_ID: "Document ID is required but missing.",
  NO_INTERNAL_IN_TOKEN: "No internal user found in token.",
  NO_INTERNAL_SIGNER: "No internal signer found.",
  NO_ORGID: "Organization ID is required but missing.",
  NO_PDF_FILE_TYPE: "PDF file type is required.",
  NO_SIGNEE: "Signee is required but missing.",
  NO_SIGNER: "Signer is required but missing.",
  NO_SIGN_IMG: "Signature image is required but missing.",
  PAGE_OUT_OF_BOUNDS: "Page number is out of bounds.",
  PDFSIGNERCORE_FALIED: "PDF signing core failed.",
  PLACEMENTS_MISSING: "Placements are missing.",
  SESSION_EXPIRED: "Session has expired.",
  SIGNATURE_IMAGE_MISSING: "Signature image is missing.",
  SIGNATURE_VERIFICATION_API_FAILED: "Signature verification API failed.",
  SIGNEES_ALREADY_EXISTS: "Signee already exists.",
  SIGNEE_DOCKET_MISMATCH: "Signee docket mismatch.",
  SIGNEE_NOT_EXTERNAL: "Signee is not external.",
  SIGNEE_NOT_INTERNAL: "Signee is not internal.",
  SIGNER_DATA_DOESNT_EXIST: "Signer data does not exist.",
  SIGNER_DOESNT_EXIST: "Signer does not exist.",
  SIGNING_HAS_STARTED: "Signing process has started.",
  SIGN_IMG_MUST_BE_JPG_OR_PNG: "Signature image must be JPG or PNG.",
  UNSUPPORTED_IMAGE_FORMAT: "Unsupported image format.",
  UNSUPPORTED_SIGN_IMAGE: "Unsupported signature image format.",
  URL_MISSING: "URL is required but missing.",
  VERIFY_ROOT_KEY_FAILED: "Root key verification failed.",
  NO_CERTIFICATE_DETAILS_FOUND: "Digital Certificate Details not found.",
  DOCKET_LINKED_DOC_DOES_NOT_EXIST: "The document linked with docket has already been released and can no longer be published. Please create a new docket for publication.",
  SIGNING_STARTED: "Someone has started the signing process. You can no longer choose signing preference.",
  APPROVAL_STARTED: "Someone has started the approval process. You can no longer choose signing preference.",
  NO_MODE: "Kindly choose your preferred signing method to proceed.",
  NO_PENDING_SIGNERS_TO_SEND: "The docket signing process is completed.Please refresh the page to view the updated status.",
  NO_ORG_EMAIL: "No organization email found.",
  INVALID_UUID: "The UUID you provided is invalid. Please provide a valid UUID.",
}

export const modifyErrorCodes = (errorCode, info) => {
  let userMsg = "Kindly contact us for support!"
  let techMsg = ""

  try {
    if (typeof errorCode === "string") {
      const error = errorCode.replace("P2BCODE::", "")

      userMsg = techMsg = errorDictionary[error] || errorCode

      console.log(error, userMsg, techMsg)

      if (error === "INVALID_TOKEN" || error === "NO_TOKEN" || error === "INVALID_ACCESS_TOKEN") {
        ApplicationState.update((state) => {
          state = {}
          return state
        })
        localStorage.clear()
        push("/")
      }
    } else {
      techMsg = errorCode.message
    }
  } catch (error) {
    techMsg = error
  } finally {
    if (techMsg && techMsg != "It seems you're offline or experiencing network disconnection.") {
      // sendErrorInfo(techMsg, info)
    }
  }
  // console.log("message", userMsg, techMsg)
  return userMsg
}

const createTxtFile = (message) => {
  // Create element with <a> tag
  const link = document.createElement("a")

  // Create a blog object with the file content which you want to add to the file
  const file = new Blob([`${message}\nTIMESTAMP: ${new Date().toLocaleString()}`], { type: "text/plain" })

  // Add file content in the object URL
  link.href = URL.createObjectURL(file)

  // Add file name
  link.download = "Docchain_error_log.txt"

  // Add click event to <a> tag to save file.
  link.click()
  URL.revokeObjectURL(link.href)
}

const sendErrorInfo = (message, info) => {
  return new Promise(async (resolve, reject) => {
    const errorInfo = `APP: ${window.location.href}\n${info}\nMESSAGE: ${message}\n${userName ? `USER: ${userName}` : ""}`

    try {
      await getRequest(`https://analytics.print2block.in/senderr?msg=${encodeURIComponent(errorInfo)}`)

      // Resolves the Promise with the retrieved data.
      resolve()
    } catch (error) {
      if (error != "P2BCODE::NETWORK_ERROR") createTxtFile(errorInfo)
      reject("Error while sending error info to analytics")
    }
  })
}
